<template>
  <v-container pa-0>
    <v-row>
      <div class="page__title">
        <div>
          <h1>Historia aktywności</h1>
        </div>
      </div>
    </v-row>

    <list-wrapper :total="count" :per-page="16">
      <history title="Historia" :show-more="false" />
    </list-wrapper>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import History from '@/components/history/History';
import ListWrapper from '@/components/list/ListWrapper';
import { listMixin } from '@/mixins/listMixin';
import { historyFilters } from '@/utils/history';

/**
 * @vuese
 * Strona historii użycia usług
 * @group History
 */
export default {
  components: { History, ListWrapper },
  mixins: [listMixin('benefitsUsage')],
  computed: mapState({ count: state => state.benefitsUsage.count }),
  methods: {
    filters(route) {
      return historyFilters(route);
    }
  }
};
</script>
